export default __webpack_public_path__ + "de612cb9c84443f080585347983590a9.png";